import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.js";
import { api, ApiError } from "../api/client.js";

export function CreateWorkspacePage() {
  const { csrfToken, refresh, selectTenant } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await api.post<{ tenantId: string; name: string; role: string }>("/workspaces", csrfToken, { name });
      await refresh();
      selectTenant(result.tenantId);
      navigate("/generate", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not create the workspace — please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div>
      <h2>Create a workspace</h2>
      <div className="card" style={{ maxWidth: 420 }}>
        {error && <div className="error-banner">{error}</div>}
        <form onSubmit={(event) => void handleSubmit(event)}>
          <div className="field">
            <label htmlFor="workspaceName">Workspace name</label>
            <input id="workspaceName" type="text" required value={name} onChange={(event) => setName(event.target.value)} />
          </div>
          <button type="submit" className="primary" disabled={submitting}>
            {submitting ? "Creating…" : "Create workspace"}
          </button>
        </form>
      </div>
    </div>
  );
}
